/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationForAzureMca extends models.BillingPeriodInformation {
    getFixupPrototypeFunction() { return BillingInformationForAzureMca.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationForAzureMca>): BillingInformationForAzureMca {
        let obj = Object.assign(new BillingInformationForAzureMca(), model);
        BillingInformationForAzureMca.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationForAzureMca>): BillingInformationForAzureMca {
        if (!model) return null;
        return BillingInformationForAzureMca.newInstance(<BillingInformationForAzureMca> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationForAzureMca) {
        if (!obj) return;

        models.BillingInformationForAzureMca.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationForAzureMca): boolean {
        if (models.BillingPeriodInformation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingInformationForAzureMca.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
